import React, { useState, useEffect } from 'react';
import { useTheme } from '../context/ThemeContext';
import { useAuth } from '../context/AuthContext';
import { useCompany } from '../context/CompanyContext';
import { useLocation } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import './Settings.css';

const TABS = ['Profile','Company','Security','Notifications','Billing','Roles'];

export default function Settings() {
  const { theme }  = useTheme();
  const { user }   = useAuth();
  const { company, update } = useCompany();
  const location = useLocation();
  const urlTab = new URLSearchParams(location.search).get('tab');
  const [tab, setTab] = useState(urlTab || 'Profile');
  useEffect(() => { if (urlTab) setTab(urlTab); }, [urlTab]);
  const [saved,  setSaved]  = useState(false);
  const [co,     setCo]     = useState(() => {
    try {
      const profile = JSON.parse(localStorage.getItem('ryzenos_company_profile') || 'null');
      const onboarding = JSON.parse(localStorage.getItem('ryzenos_company') || 'null');
      return profile || onboarding || company;
    } catch { return company; }
  });

  /* Profile state -- controlled inputs */
  const [profile, setProfile] = useState(() => {
    try { return JSON.parse(localStorage.getItem('ryzenos_user_profile') || 'null') || {name:user.name||'',email:user.email||'',phone:'',dept:user.dept||''}; } catch { return {name:user.name||'',email:user.email||'',phone:'',dept:user.dept||''}; }
  });
  const setP = (k,v) => setProfile(p=>({...p,[k]:v}));
  const setCof = (k,v) => setCo(p=>({...p,[k]:v}));

  /* Security state */
  const [sec, setSec] = useState({cur:'',newPw:'',confirm:''});
  const [secMsg, setSecMsg] = useState('');
  const setS = (k,v) => setSec(p=>({...p,[k]:v}));

  const showSaved = () => { setSaved(true); setTimeout(()=>setSaved(false),2000); };

  const saveProfile = () => {
    localStorage.setItem('ryzenos_user_profile', JSON.stringify(profile));
    showSaved();
  };

  const saveCompany = () => {
    update(co);
    localStorage.setItem('ryzenos_company_profile', JSON.stringify(co));
    showSaved();
  };

  const updatePassword = () => {
    if (!sec.cur) { setSecMsg('Enter your current password'); return; }
    if (sec.newPw.length < 6) { setSecMsg('New password must be at least 6 characters'); return; }
    if (sec.newPw !== sec.confirm) { setSecMsg('Passwords do not match'); return; }
    /* Update in team localStorage */
    try {
      const team = JSON.parse(localStorage.getItem('ryzenos_team') || '[]');
      const updated = team.map(m => m.username === user.username ? {...m, password: sec.newPw} : m);
      localStorage.setItem('ryzenos_team', JSON.stringify(updated));
    } catch {}
    setSecMsg('Password updated successfully');
    setSec({cur:'',newPw:'',confirm:''});
    setTimeout(()=>setSecMsg(''),3000);
  };

  return (
    <div className="st-wrap" data-theme={theme}>
      <Sidebar/>
      <div className="st-main">
        <Topbar title="Settings" subtitle="Manage your account and workspace"/>
        <div className="st-body">
          <div className="st-nav">
            {TABS.map(t=><div key={t} className={`st-nav-item${tab===t?' active':''}`} onClick={()=>setTab(t)}>{t}</div>)}
          </div>
          <div className="st-content">

            {tab==='Profile' && (
              <div className="st-section">
                <div className="st-sec-title">My Profile</div>
                <div className="st-av-row">
                  <div className="st-av">{user.initials}</div>
                  <div>
                    <div className="st-av-name">{profile.name||user.name}</div>
                    <div className="st-av-role">{user.role}</div>
                  </div>
                </div>
                <div className="st-fields">
                  <div className="st-field-grp"><label className="st-lbl">Name</label><input className="st-inp" value={profile.name} onChange={e=>setP('name',e.target.value)}/></div>
                  <div className="st-field-grp"><label className="st-lbl">Email</label><input className="st-inp" value={profile.email} onChange={e=>setP('email',e.target.value)}/></div>
                  <div className="st-field-grp"><label className="st-lbl">Phone</label><input className="st-inp" value={profile.phone} placeholder="+91 XXXXX XXXXX" onChange={e=>setP('phone',e.target.value)}/></div>
                  <div className="st-field-grp"><label className="st-lbl">Department</label><input className="st-inp" value={profile.dept} onChange={e=>setP('dept',e.target.value)}/></div>
                </div>
                <div className="st-save-row">
                  <button className="st-save-btn" onClick={saveProfile}>{saved?'✓ Saved':'Save changes'}</button>
                </div>
              </div>
            )}

            {tab==='Company' && (
              <div className="st-section">
                <div className="st-sec-title">Company Profile</div>
                <div className="st-fields">
                  {[
                    {k:'name',    label:'Company name',   placeholder:'Ryzenforge Enterprises LLP'},
                    {k:'tagline', label:'Tagline',         placeholder:'Run your business smarter'},
                    {k:'email',   label:'Business email',  placeholder:'connect@ryzenforge.com'},
                    {k:'phone',   label:'Phone',           placeholder:'+91 81295 82113'},
                    {k:'website', label:'Website',         placeholder:'www.ryzenforge.com'},
                    {k:'gstin',   label:'GSTIN',           placeholder:'22AAAAA0000A1Z5'},
                    {k:'address', label:'Address',         placeholder:'Tower 2, DD Platinum Planet'},
                    {k:'city',    label:'City',            placeholder:'Kochi'},
                    {k:'state',   label:'State',           placeholder:'Kerala'},
                    {k:'pincode', label:'Pincode',         placeholder:'682017'},
                  ].map(f=>(
                    <div key={f.k} className="st-field-grp">
                      <label className="st-lbl">{f.label}</label>
                      <input className="st-inp" placeholder={f.placeholder} value={co[f.k]||''} onChange={e=>setCof(f.k,e.target.value)}/>
                    </div>
                  ))}
                </div>
                <div className="st-save-row">
                  <button className="st-save-btn" onClick={saveCompany}>{saved?'✓ Saved':'Save company profile'}</button>
                </div>
              </div>
            )}

            {tab==='Security' && (
              <div className="st-section">
                <div className="st-sec-title">Security</div>
                <div className="st-fields">
                  <div className="st-field-grp"><label className="st-lbl">Current password</label><input className="st-inp" type="password" value={sec.cur} onChange={e=>setS('cur',e.target.value)} placeholder="••••••••"/></div>
                  <div className="st-field-grp"><label className="st-lbl">New password</label><input className="st-inp" type="password" value={sec.newPw} onChange={e=>setS('newPw',e.target.value)} placeholder="••••••••"/></div>
                  <div className="st-field-grp"><label className="st-lbl">Confirm password</label><input className="st-inp" type="password" value={sec.confirm} onChange={e=>setS('confirm',e.target.value)} placeholder="••••••••"/></div>
                </div>
                {secMsg && <div className={`st-msg ${secMsg.includes('success')?'st-msg-ok':'st-msg-err'}`}>{secMsg}</div>}
                <div className="st-save-row"><button className="st-save-btn" onClick={updatePassword}>Update password</button></div>
              </div>
            )}

            {tab==='Notifications' && (
              <div className="st-section">
                <div className="st-sec-title">Notification Preferences</div>
                {[
                  {key:'followup',  label:'Follow-up reminders',   desc:'Get notified when a lead follow-up is due'},
                  {key:'invoice',   label:'Invoice due alerts',     desc:'Get notified when an invoice is overdue'},
                  {key:'team',      label:'Team attendance',        desc:'Daily attendance summary at 10 AM'},
                  {key:'lead',      label:'New lead alerts',        desc:'Notify when a new lead is added'},
                  {key:'task',      label:'Task deadlines',         desc:'Remind 1 day before a task is due'},
                ].map(n => {
                  const stored = JSON.parse(localStorage.getItem('ryzenos_notif_prefs') || '{}');
                  const isOn = stored[n.key] !== false;
                  return (
                    <div key={n.key} className="st-notif-row">
                      <div>
                        <div className="st-notif-lbl">{n.label}</div>
                        <div className="st-notif-desc">{n.desc}</div>
                      </div>
                      <div className={`st-toggle${isOn?' on':''}`} onClick={()=>{
                        const p = JSON.parse(localStorage.getItem('ryzenos_notif_prefs') || '{}');
                        p[n.key] = !isOn;
                        localStorage.setItem('ryzenos_notif_prefs', JSON.stringify(p));
                        showSaved();
                      }}><div className="st-toggle-thumb"/></div>
                    </div>
                  );
                })}
              </div>
            )}

            {tab==='Billing' && (
              <div className="st-section">
                <div className="st-sec-title">Billing</div>
                <div className="st-billing-card">
                  <div className="st-plan-name">RyzenOS Pro</div>
                  <div className="st-plan-price">₹7,499 <span>/month</span></div>
                  <div className="st-plan-status">✓ Active — Next billing 26 June 2026</div>
                </div>
                <div className="st-billing-info">
                  {[{label:'Plan',val:'Pro — Unlimited leads, team, finance'},{label:'Users',val:'Up to 25 team members'},{label:'Storage',val:'50 GB'},{label:'Support',val:'Priority support'}].map(r=>(
                    <div key={r.label} className="st-info-row"><span className="st-info-lbl">{r.label}</span><span className="st-info-val">{r.val}</span></div>
                  ))}
                </div>
                <div className="st-save-row"><button className="st-cancel-btn" onClick={()=>alert('Please contact support@ryzenforge.com to cancel your subscription.')}>Cancel subscription</button></div>
              </div>
            )}

            {tab==='Roles' && (
              <div className="st-section">
                <div className="st-sec-title">Roles & Permissions</div>
                <div className="st-roles-info">Roles are assigned from the Team page. Each role controls what a member can see and do.</div>
                {[
                  {role:'Super Admin',color:'#F5A623',perms:['Full access to all modules','Add/edit/delete leads, clients, team','Manage billing and settings','View all reports and analytics']},
                  {role:'Admin',color:'#3B82F6',perms:['View all modules','Add/edit leads, clients, projects','Cannot delete team members','Cannot access billing']},
                  {role:'User',color:'#22C55E',perms:['Access employee portal only','Mark own attendance','View assigned tasks','Cannot access CRM data']},
                ].map(r=>(
                  <div key={r.role} className="st-role-card">
                    <div className="st-role-hd"><div className="st-role-name" style={{color:r.color}}>{r.role}</div></div>
                    <ul className="st-role-perms">{r.perms.map(p=><li key={p} className="st-role-perm">{p}</li>)}</ul>
                  </div>
                ))}
              </div>
            )}

          </div>
        </div>
      </div>
    </div>
  );
}
